<template>
  <Dialog v-model="dialogDelete" icon="fas fa-trash-alt" title="確認">
    <template v-slot:content>削除します。よろしいですか。</template>
    <template v-slot:actions>
      <v-btn small color @click="dialogDelete = false">キャンセル</v-btn>
      <v-btn
        small
        color="error"
        :loading="loading"
        @click="handleDelete(item.Id)"
        >OK</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import { deleteBadge } from "@/api/Badge.api";
import Dialog from "@/components/Dialog/Dialog";
export default {
  props: ["item"],
  components: { Dialog },
  data() {
    return {
      dialogDelete: false,
      loading: false,
    };
  },
  methods: {
    async handleDelete() {
      this.loading = true;
      let params = {
        Id: this.item.Id,
      };
      await deleteBadge(params)
        .then(() => {
          this.$emit("resetList");
          this.loading = false;
          this.dialogDelete = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCancel() {
      this.$emit("resetList");
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>